import logo from '../assets/outclose_horizontal.svg';

export default function Logo({ className = '', link = 'https://outclose.com' }: { className?: string; link?: string }) {
  return (
    <a href={link} className={`flex items-center gap-2 font-Poppins ${className}`}>
      <img src={logo} alt="Outclose" className="h-6 w-auto dark:invert" />
    </a>
  );
}
